import { render, staticRenderFns } from "./GovernanceCard.vue?vue&type=template&id=322b73c1&scoped=true&"
import script from "./GovernanceCard.vue?vue&type=script&lang=js&"
export * from "./GovernanceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b73c1",
  null
  
)

export default component.exports